module.exports = __webpack_public_path__ + "media/MRI5A.8bbed5fc.mp3";